import React from 'react'
import { Link } from 'react-router-dom';

function SidebarLink({children, linkTitle, link, active, id, collapsed}) {

  var activeWord = "";
  if(active == id) activeWord = "active";

  const icon = collapsed
    ? React.cloneElement(children, { style: { ...(children.props?.style || {}), marginRight: 0 } })
    : children;

  return (
    <li className={"sidebar-item " + activeWord}>
      <Link
        className="sidebar-link"
        to={link}
        style={collapsed ? { display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px 0' } : {}}
      >
        {icon}
        {!collapsed && <span className="align-middle">{linkTitle}</span>}
      </Link>
    </li>
  )
}

export default SidebarLink